import { render, staticRenderFns } from "./Banner1Form.vue?vue&type=template&id=6cbaae52&scoped=true&"
import script from "./Banner1Form.vue?vue&type=script&lang=js&"
export * from "./Banner1Form.vue?vue&type=script&lang=js&"
import style0 from "./Banner1Form.vue?vue&type=style&index=0&id=6cbaae52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbaae52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFileInput,VIcon,VProgressLinear,VSpacer,VTextField})
